<template>
  <div v-if="showDistributorLabels">
    <b-badge
      v-if="type === 'A'"
      variant="light"
      class="text-md px-3 py-2 g-badge"
      >{{ $t("listing.instantBooking") }}</b-badge
    >
    <b-badge
      v-if="type === 'A' && !hideRealTimeBadge"
      variant="light"
      class="text-md px-3 py-2 ml-2 g-badge"
      >{{ $t("listing.realTime") }}</b-badge
    >
    <b-badge
      v-if="type === 'B'"
      variant="light"
      class="text-md px-3 py-2 g-badge"
      >{{ instantBookingLabel }}</b-badge
    >
    <b-badge
      v-if="['C', 'D'].includes(type)"
      variant="light"
      class="text-md px-3 py-2 g-badge"
      >{{ $t("listing.bookingOnRequest") }}</b-badge
    >
    <b-badge
      v-if="type === 'C'"
      variant="light"
      class="text-md px-3 ml-2 py-2 g-badge"
      >{{ $t("listing.verifiedByGoogle") }}</b-badge
    >
    <b-badge
      v-if="type === 'D'"
      variant="light"
      class="text-md px-3 ml-2 py-2 g-badge"
      >{{ $t("listing.notVerified") }}</b-badge
    >
  </div>
</template>

<script>
import { nuiteeSupplierId } from "@/shared";
import { currentConfigKey } from "@/helpers/theme";

export default {
  name: "DistributorLabel",
  props: {
    type: {
      type: String,
      required: true,
    },
    supplierId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    showDistributorLabels() {
      return currentConfigKey("showDistributorLabels", true);
    },
    hideRealTimeBadge() {
      return currentConfigKey("hideRealTimeBadge", false);
    },
    instantBookingLabel() {
      if (this.type !== "B") return "";
      return Number(this.supplierId) === nuiteeSupplierId
        ? this.$t("listing.instantBookingNuitee")
        : this.$t("listing.instantBooking");
    },
  },
};
</script>
